"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var account_1 = tslib_1.__importDefault(require("../../system/account"));
var paycode_1 = tslib_1.__importDefault(require("../../system/paycode"));
var fee_1 = tslib_1.__importDefault(require("../../system/fee"));
var occcode_1 = tslib_1.__importDefault(require("../../system/occcode"));
var address_1 = tslib_1.__importDefault(require("../../system/address"));
var assignment_1 = tslib_1.__importDefault(require("../../system/assignment"));
var lines_2 = tslib_1.__importDefault(require("./lines"));
var _1 = tslib_1.__importDefault(require("."));
var employee_1 = tslib_1.__importDefault(require("../../system/employee"));
// @todo
//  /lines/prd/accumulation
var PayrollDetailLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(PayrollDetailLineResource, _super);
    function PayrollDetailLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PayrollDetailLineResource, "related", {
        get: function () {
            return Object.assign({}, lines_1.BaseLineResource.related, {
                transaction_id: _1.default,
                account: account_1.default,
                pay_code: paycode_1.default,
                fee: fee_1.default,
                occ_code: occcode_1.default,
                work_address: address_1.default,
                assignment: assignment_1.default,
                payroll_line: lines_2.default,
                referencing_line: PayrollDetailLineResource,
                related_fee: fee_1.default,
                employee: employee_1.default
            });
        },
        enumerable: true,
        configurable: true
    });
    PayrollDetailLineResource.endpoint = '/lines/prd';
    PayrollDetailLineResource.MODEL_NAME = 'payrolldetailline';
    PayrollDetailLineResource.defaults = Object.assign({}, lines_1.BaseLineResource.defaults, {
        type: 'PAY'
    });
    return PayrollDetailLineResource;
}(lines_1.BaseLineResource));
exports.default = PayrollDetailLineResource;
//# sourceMappingURL=payrolldetailline.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/pr/payrolldetailline.js
// module id = wYa6
// module chunks = 0